// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1_dmZ","content":"styles_content__716yy"};